module.exports = __webpack_public_path__ + "img/20191028171920176.a3f5b356.jpg";